import { sample } from 'effector';
import {
  calculateThresholdsEv,
  putBlockedBucketsEv,
  putThresholdsEv,
  resetBlockedBucketsEv,
} from './events.js';
import { $blockedBuckets, $gradientBuckets } from './stores.js';
import { bucketsByAlgorithmFx } from './effects.js';
import { gradient_colors } from '../../dictionaries/gradient_dictionary.js';
import { hideLoaderEv } from '../logicModel/index.js';

$blockedBuckets.reset(resetBlockedBucketsEv);

sample({
  source: $blockedBuckets,
  clock: putBlockedBucketsEv,
  fn: (source, clock) => {
    return {
      ...source,
      [clock.zoom]: clock.value,
    };
  },
  target: $blockedBuckets,
});

sample({
  clock: calculateThresholdsEv,
  fn: (clock) => {
    return {
      hexagons: clock,
    };
  },
  target: bucketsByAlgorithmFx,
});

sample({
  clock: bucketsByAlgorithmFx.doneData,
  target: putThresholdsEv,
});

sample({
  source: $gradientBuckets,
  clock: putThresholdsEv,
  fn: (gradientBuckets, clock) => {
    const { buckets } = clock;
    const colors = gradient_colors.lightV2;
    return {
      buckets,
      colors,
    };
  },
  target: [$gradientBuckets, hideLoaderEv],
});
